import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { URLS } from '../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-ad-landingpage-top-bar',
  templateUrl: './ad-landingpage-top-bar.component.html',
  styleUrls: [
    './ad-landingpage-top-bar.component.css',
    './../../portal-home/login-home/login-home.component.css'
  ]
})
@TraceClassDecorator()
export class AdLandingpageTopBarComponent implements OnInit {
  activeRoute: string;
  is_uk_country: boolean = false;
  slug: string = "";
  constructor(
    private router: Router,
    private utilitiesService: UtilitiesService,
    private readonly providerstateService: ProviderStateService
  ) { }

  newChange(): void {
    this.router.navigate(['/' + this.slug + '/news']);
  }

  date_of_birth: Date = null;
  logo_url: string = "";
  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    this.logo_url = this.providerstateService.getLogoUrl();
    if (URLS.IS_UK) {
      this.is_uk_country = true;
    }
    await this.setWidthNav();
    this.activeRoute = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = this.router.url;
      }
    });
  }

  RouterNavigation(path: string) {
    this.router.navigate(['/' + this.slug + '/' + path]);
  }

  // function setWidthNav() {
  async setWidthNav() {
    // var ele = document.getElementById("mySidepanel");
    // ele.style.width = "0px";
    let ele = <HTMLElement>document.getElementById('mySidepanel');
    ele.style.width = '0px';
  }

  // function openNav() {
  openNav() {
    document.getElementById('mySidepanel').style.width = '280px';
  }

  // function closeNav() {
  closeNav() {
    document.getElementById('mySidepanel').style.width = '0';
  }

  // function toggleNav() {
  toggleNav() {
    // let ele = document.getElementById("mySidepanel");
    if (document.getElementById('mySidepanel').style.width !== '0px') {
      this.closeNav();
    } else if (document.getElementById('mySidepanel').style.width === '0px') {
      this.openNav();
    }
  }

  async openLink(link: string): Promise<void> {
    await this.router.navigate(['/' + this.slug + '/' + link]);
  }

  async openBaseLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }
  isRouteActive(route: string): boolean {
    return this.activeRoute === route;
  }
}
